// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"press-module--wrapper--23czE"};